/**
 * @desc 项目配置文件
 */
import info from '../constants/info';
import messager from '../utils/messager';
import StatusCode from '../constants/statusCode';
import { HttpMethod, ContentType } from '../constants/enum';
import { clear } from '../utils/storage';

export default {
    messagerDuration: 2, // 系统提示信息显示时间, 默认3秒
    higgsPromise: {
        // higgsPromise默认配置
        cache: false,
        timeout: 60000, // 由于请求数据量较大，将超时时间改为1分钟，待后端优化后再缩短
        showError: true,
        processError: true,
        messager: messager,
        enableLoading: null, // 默认post请求时会显示loading动画
        type: HttpMethod.GET, // 默认请求方式
        contentType: ContentType.JSON, // API接口请求默认发送的contentType
        responseInterceptor: function(data, resolve, reject) {
            // 根据接口返回数据判断是否请求成功 (1:成功；0:失败；403:未登录)
            if (Number(data.code) === 1) {
                resolve(data.data);
            } else {
                var errorMessage;
                // 默认错误处理
                if (this.processError) {
                    switch (data.code) {
                        case StatusCode.REQUIRED_TOKEN: // 没有登陆:403
                            clear(); // 清除缓存--storage
                            errorMessage = info.REQUIRED_TOKEN_ERROR;
                            if (location.href.indexOf('login') === -1) { // 防止多个接口，多次跳转
                                location.href = `/#/login?callback=${encodeURIComponent(location.href)}`;
                            }
                            break;
                        case StatusCode.SYSTEM_ERROR: // 系统异常
                            errorMessage = info[500];
                            break;
                        default:
                            // 未知错误
                            errorMessage = data.msg || info[500];
                    }
                    if (this.showError) {
                        // this.messager.error(errorMessage);
                    }
                }
                if (errorMessage) {
                    data.msg = errorMessage;
                }
                reject(data);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/config/config.js